import Box from '@mui/material/Box'

import { KestrixButton } from '../buttons/KestrixButton/KestrixButton.tsx'
import {
  borderRadius,
  componentTokens,
  spacing
} from '../KestrixDesignSystem.jsx'
import KestrixModal from '../KestrixModal.jsx'
import { KestrixTrashIcon } from '../KestrixSvgIcons.jsx'
import { colorTokens } from '../tokens/colors.ts'
import KestrixV2Typography from '../typography/KestrixTypography.tsx'

interface ViewTabDeleteConfirmModalProps {
  open: boolean
  viewName: string
  onConfirm: () => void
  onCancel: () => void
}

const errorSoft = colorTokens.semantic.status.errorSoftEmphasis

const modalButtonSx = {
  minHeight: componentTokens.button.height.sm,
  height: componentTokens.button.height.sm,
  py: 0
} as const

export const ViewTabDeleteConfirmModal = ({
  open,
  viewName,
  onConfirm,
  onCancel
}: ViewTabDeleteConfirmModalProps) => (
  <KestrixModal
    open={open}
    onClose={onCancel}
    size="small"
    showCloseButton={false}
    dataTestId="view-tab-delete-modal"
    aria-labelledby="view-tab-delete-title"
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing[4] }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: spacing[10],
          height: spacing[10],
          borderRadius: borderRadius.full,
          backgroundColor: errorSoft.surface,
          flexShrink: 0
        }}
      >
        <KestrixTrashIcon
          size={18}
          color={errorSoft.icon}
          sx={{ color: errorSoft.icon }}
          aria-hidden
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing[1] }}>
        <KestrixV2Typography
          id="view-tab-delete-title"
          data-testid="view-tab-delete-title"
          variant="bodyMedium"
          weight="semibold"
          color="body-neutral"
          htmlTag="p"
          sx={{ m: 0 }}
        >
          Delete &ldquo;{viewName}&rdquo;?
        </KestrixV2Typography>
        <KestrixV2Typography
          variant="bodySmall"
          weight="regular"
          color="subtext-neutral"
          htmlTag="p"
          sx={{ m: 0, lineHeight: 1.7 }}
        >
          This view will be permanently deleted and cannot be recovered.
        </KestrixV2Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: spacing[2],
          justifyContent: 'flex-end',
          pt: spacing[1]
        }}
      >
        <KestrixButton
          variant="default"
          size="small"
          icon={null}
          iconPosition="start"
          iconOnly={false}
          loading={false}
          onClick={onCancel}
          data-testid="view-tab-delete-cancel"
          sx={modalButtonSx}
        >
          Cancel
        </KestrixButton>
        <KestrixButton
          variant="danger"
          size="small"
          icon={null}
          iconPosition="start"
          iconOnly={false}
          loading={false}
          onClick={onConfirm}
          data-testid="view-tab-delete-confirm"
          sx={modalButtonSx}
        >
          Delete view
        </KestrixButton>
      </Box>
    </Box>
  </KestrixModal>
)
